<template>
  <div>
    <h4 class="report-module-title">
      {{ $t('KPI Reports (Monthly)') }}
    </h4>

    <el-table :data="VisitReport.list.data"
              :empty-text="VisitReport.list.isLoading ? $t('Loading...') : $t('No Data')"
              max-height="500">
      <HorizontalLoading v-show="VisitReport.list.isLoading"
                         slot="append" />
      <el-table-column :label="$t('Display name')"
                       prop="display_name"
                       width="700"
                       sortable>
        <template slot-scope="scope">
          <a href="#" @click="downloadReport(scope.row.file_url, scope.row.display_name)">{{ scope.row.display_name }}</a>
        </template>
      </el-table-column>

      <el-table-column :label="$t('Created at')"
                       prop="created_at"
                       min-width="150"
                       sortable>
        <template slot-scope="scope">
          {{ normalizeDate(scope.row.created_at) }}
        </template>
      </el-table-column>

      <el-table-column v-if="isDeveloper"
                       width="80">
        <template slot-scope="scope">
          <el-button type="primary"
                     icon="el-icon-close"
                     @click="deleteReport(scope.row)" />
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="downloadingDialog"
               :title="$t('In Progress')"
               center
               append-to-body>
      <div style="display: flex; justify-content: center;">
        <i class="el-icon-loading" style="font-size: 40px;" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Message } from 'element-ui';
import { deleteReport } from '@/modules/report/api';
import { downloadFile } from '@/shared/apis';

export default {
  name: 'VisitReport',
  props: {
    projectId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      downloadingDialog: false
    };
  },
  computed: {
    ...mapState(['VisitReport', 'Account']),
    isDeveloper() {
      return this.Account.active.data.developer;
    }
  },
  beforeDestroy() {
    this.cleanReportList();
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions(['fetchVisitReports', 'cleanReportList']),
    fetchData() {
      const { projectId } = this;

      this.fetchVisitReports({
        projectId
      });
    },
    downloadReport(url, title) {
      this.downloadingDialog = true;

      downloadFile(url, title).finally(() => {
        this.downloadingDialog = false;
      });
    },
    deleteReport(row) {
      const message = this.$t('This report <b>{itemName}</b> will be deleted. This action can not be undone', { itemName: row.display_name });

      return this.$confirm(
        message,
        this.$t('Confirmation'),
        {
          type: 'warning',
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('Delete'),
          cancelButtonText: this.$t('Cancel')
        }
      )
        .then(() => deleteReport(this.projectId, row.id))
        .then(() => {
          Message({ type: 'info', message: this.$t('Report deleted.') });
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        })
        .catch((err) => {
          this.ValidatedCrops.hasError = true;
          Message({ type: 'error', message: this.$t('Report couldn\'t be deleted.') });

          return Promise.reject(err);
        });
    }
  }
};
</script>
